import Entity from '../../schema/Entity';
import calculateOrigin from './calculateOrigin';
import AdditionalInfo from '../../schema/innerSchema/AdditionalInfo';

/**
 * parse data for basic Entity
 */
export default function setBasicEntityData(entity: any, useEntityId: boolean): Entity {
    if (entity) {
        let id: string = useEntityId ? entity['@EntityId'] : entity['@id'];

        if (id) {
            const txpAdditionalType: AdditionalInfo =
                AdditionalInfo[entity['additionalType/Txp'] as string];
            const source = entity['@source'];
            const origin = calculateOrigin(txpAdditionalType, source);
            const originEmails = entity['originEmails/Txp'];
            const inferenceId = entity['@inferenceId'];
            const immutableMessageIds = entity.immutableMessageIds;
            let originalEmailEwsId = null;
            let originalEmailReceivedTime = null;
            let originalEmailInternetMessageId = null;

            if (originEmails && originEmails.length) {
                originalEmailEwsId = originEmails[0].ewsId;
                originalEmailReceivedTime = originEmails[0].receivedTime;
                originalEmailInternetMessageId = originEmails[0].internetMessageId;
            }

            return {
                id: id,
                source: source,
                trustScore: entity['@entityExtractionTrustLevel'],
                txpAdditionalType: txpAdditionalType,
                origin: origin,
                originalEmailEwsId: originalEmailEwsId,
                originalEmailReceivedTime: originalEmailReceivedTime,
                originalEmailInternetMessageId: originalEmailInternetMessageId,
                inferenceId: inferenceId,
                immutableMessageIds: immutableMessageIds,
            } as Entity;
        }
    }

    return null;
}
